<template>
  <d2-container>
    <h2>开通企业</h2>
    <el-form ref="elForm" size="medium" label-width="110px">
      <el-row type="flex" justify="start" align="top">
        <el-form-item label="注册区县" prop="cityReq">
           <town-com v-on:on-selectLast="(e)=>listQuery.addressStreetId=e"></town-com>
        </el-form-item>
        <el-form-item label="企业类型" prop="entTypeReq">
          <el-select v-model="listQuery.entType" placeholder="请选择企业类型" clearable :style="{width: '100%'}">
            <el-option v-for="(item, index) in entTypeOptions" :key="index" :label="item.label" :value="item.value"
                       :disabled="item.disabled"></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row type="flex" justify="start">
        <el-form-item  label="企业名称">
          <el-input v-model="listQuery.entName" placeholder="请输入企业名称"
                    clearable :style="{width: '545px'}"></el-input>
        </el-form-item>
        <el-form-item size="large">
          <el-button size="small" class="filter-item" type="primary" icon="search" @click="handleFilter">查询</el-button>
          <el-button size="small" @click="resetForm">重置</el-button>
        </el-form-item>
      </el-row>
    </el-form>


    <!--新增按钮-->
    <el-button size="small" class="filter-item" style="margin-left: 10px;"
               @click="handleCreate" type="primary"
               icon="edit">新增企业
    </el-button>
    <!--表格-->
    <el-tabs v-model="listQuery.status" @tab-click="handleFilter">
      <el-tab-pane label="未开通" name="0"></el-tab-pane>
    </el-tabs>
    <el-table :key='tableKey' :data="list" v-loading.body="listLoading" size="small" stripe
              highlight-current-row
              style="width: 100%">
      <el-table-column
          type="selection"
          width="55" label="序号">
      </el-table-column>
      <el-table-column
              prop="date"
              label="企业类型"
              width="140">
        <template slot-scope="scope">
          <span>{{ scope.row.entType==0?'加油企业':'供油企业' }}</span>
        </template>
      </el-table-column>
      <el-table-column
          fixed
          prop="date"
          label="企业名称"
          width="220">
        <template slot-scope="scope">
          <span>{{ scope.row.entName }}</span>
        </template>
      </el-table-column>
      <!--<el-table-column-->
          <!--prop="name"-->
          <!--label="办公地址"-->
          <!--width="240">-->
        <!--<template slot-scope="scope">-->
          <!--<span>{{ scope.row.workAddressName }}/{{ scope.row.workAddressDetail }}</span>-->
        <!--</template>-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
          <!--prop="province"-->
          <!--label="注册区县"-->
          <!--width="220">-->
        <!--<template slot-scope="scope">-->
          <!--<span>{{ scope.row.regAddressName }}/{{ scope.row.regAddressDetail }}</span>-->
        <!--</template>-->
      <!--</el-table-column>-->
      <el-table-column
          prop="province"
          label="所属街镇"
          width="320">
        <template slot-scope="scope">
          <span>{{ scope.row.addressStreetName }}/{{ scope.row.addressStreetDetail }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="city"
          label="法人代表"
          width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.legalName }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="address"
          label="联系人">
        <template slot-scope="scope">
          <span>{{ scope.row.contactName }}</span>
        </template>
      </el-table-column>
      <el-table-column
          fixed="right"
          align="center"
          width="300"
          label="操作">
        <template slot-scope="scope">
          <el-button size="small" @click="handleClick(scope.row)">查看</el-button>
          <el-button size="small" type="success" @click="handleUpdate(scope.row)" v-if="scope.row.status===0">编辑</el-button>
          <!--<el-button size="small" type="warning" @click="handleAudit(scope.row)" v-if="scope.row.status===1">审核</el-button>-->
          <el-button size="small" type="danger" @click="handleDelete(scope.row)" v-if="scope.row.status==0 || scope.row.status==-1">删除</el-button>
          <el-button size="small" type="warning" @click="handleOpen(scope.row)" v-if="scope.row.status==-1 || scope.row.status==2">重新开通</el-button>
          <el-button size="small" type="warning" @click="handleOpen(scope.row)" v-if="scope.row.status==0">开通</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <template slot="footer">
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page.sync="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </template>

    <!--新增企业-->
    <el-dialog :fullscreen="false" :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" v-if="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form" label-width="180px">
        <el-row type="flex" justify="start" align="top">
          <el-form-item label="企业类型" prop="entName">
            <el-select v-model="form.entType" placeholder="请选择企业类型" clearable style="width:202px;">
              <el-option v-for="(item, index) in entTypeOptions" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在数据服务商" prop="creditCode">
            <el-select v-model="form.devId" placeholder="请选择数据服务商" @change="devId=>this.form.platformName=devName(devId)" clearable style="width:202px;">
              <el-option v-for="(item, index) in devList" :key="index" :label="item.platformName" :value="item.devId"
                         :disabled="item.disabled"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="start" align="top">
          <el-form-item label="企业名称" prop="entName">
            <el-input v-model="form.entName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="creditCode">
            <el-input v-model="form.creditCode" placeholder="请输入"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="start" align="top">
          <el-form-item label="负责人" prop="contactName">
            <el-input v-model="form.contactName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="contactPhone">
            <el-input v-model="form.contactPhone" placeholder="请输入"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="start" align="top">
          <el-form-item label="法人代表" prop="legalName">
            <el-input v-model="form.legalName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="legalPhone">
            <el-input v-model="form.legalPhone" placeholder="请输入"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="start" align="top">
          <el-form-item label="所属行业" prop="legalName">
            <el-input v-model="form.industry" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="初始签章次数" prop="signatureCount">
            <el-input v-model="form.signatureCount" placeholder="请输入0-1000范围的数字" v-number="0-1000"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="start" align="top">
          <el-form-item label="注册地址" prop="regAddressId" >
            <town-com  v-on:on-selectLast="(e)=>form.regAddressId=e" v-on:on-labels="(e)=>form.regAddressName=e.join('')" :no-type="'street'"  :selectValue="form.regAddressId"></town-com>
          </el-form-item>
          <el-form-item label="" prop="regAddressDetail" label-width="10px" style="width:400px;">
            <el-input v-model="form.regAddressDetail" placeholder="请输入"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="start" align="top">
          <el-form-item label="经营地址" prop="workAddressId">
            <town-com v-on:on-selectLast="(e)=>form.workAddressId=e" v-on:on-labels="(e)=>form.workAddressName=e.join('')" :no-type="'street'" :selectValue="form.workAddressId"></town-com>
          </el-form-item>
          <el-form-item label="" prop="workAddressDetail" label-width="10px" style="width:400px;">
            <el-input v-model="form.workAddressDetail" placeholder="请输入" width="200px"></el-input>
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="start" align="top">
          <el-form-item label="所属街镇" prop="addressStreetId" required>
            <town-com v-on:on-select="(e)=>{form.addressCityId=e[0];form.addressCountyId=e[1];form.addressStreetId=e[2];}" v-on:on-labels="(e)=>form.addressStreetName=e.join('')" :selectValue="form.addressStreetId"></town-com>
          </el-form-item>
          <el-form-item label="" prop="addressStreetDetail" label-width="10px" style="width:400px;">
            <el-input v-model="form.addressStreetDetail" placeholder="请输入" width="200px"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')" size="small">取 消</el-button>
        <el-button v-if="dialogStatus=='create'" size="small" type="primary" @click="create('form')">确 定</el-button>
        <el-button v-else type="primary" size="small" @click="update('form')">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog title="企业开通" :visible.sync="dialogServiceVisible" width="65%">
      <ent-service :entId="currentEntId" v-if="dialogServiceVisible" @success="close(true)" @close="close()"></ent-service>
    </el-dialog>

    <el-dialog title="详情" :visible.sync="dialogDetailVisible">
      <ent-detail :entId="currentEntId" v-if="dialogDetailVisible" @close="close()"></ent-detail>
    </el-dialog>

    <!--<el-dialog title="审核" :visible.sync="dialogAuditVisible">-->
      <!--<ent-detail :entId="currentEntId" v-if="dialogAuditVisible" @close="close()">-->
        <!--<div slot="audit">-->
          <!--<audit-com :entId="currentEntId" @success="close(true)" @close="close()"></audit-com>-->
        <!--</div>-->
      <!--</ent-detail>-->
    <!--</el-dialog>-->
  </d2-container>
</template>


<script>
import {
  addObj,
  delObj,
  enterpriseDetail,
  getObj,
  listPage,
  putObj,
  selectBaseTown,
  rejectOpenDetail
} from '@/api/admin/sysEnterprise/index';
import {getDevList} from '@/api/admin/sysDevApp/index';
import {mapGetters} from 'vuex';
import TownCom from "../common/town-com.vue";
import EntDetail from "./detail.vue";
import EntService from "./service.vue";
import AuditCom from "./audit.vue";

export default {
  name: 'sysEnterprise',
  components: {
    TownCom, AuditCom, EntDetail, EntService
  },
  data() {
    return {
      dialogFormVisible: false,//新增、编辑
      dialogAuditVisible: false,//审核
      dialogDetailVisible: false,//审核
      dialogServiceVisible: false,//企业开通
      listQuery: {
        addressStreetId: null,
        entType: null,
        entName: null,
        page: 1,
        limit: 20,
        status: 0
      },
      devList:[],
      devMap:{},
      entTypeOptions: [{
        "label": "加油",
        "value": 0
      }, {
        "label": "供油",
        "value": 1
      }],
      currentEntId: null,
      initForm:{},
      form: {
        devId: null,
        platformName:null,
        contactName: null,//联系人
        contactPhone: null,//联系方式
        creditCode: null,//统一社会信用代码
        entName: null,//企业名称
        entType: null,//企业类型
        legalName: null,//法人代表
        legalPhone: null,//联系方式
        industry: null,//所属行业

        regAddressId: null,//注册地址
        regAddressName: null,//注册地址
        regAddressDetail: null,//注册地址详情

        workAddressId: null,//办公地址ID
        workAddressName: null,//办公地址名称
        workAddressDetail: null,//办公地址详情

        addressCityId: null,//所属市编号
        addressCountyId: null,
        addressStreetId: null,//所属区编号
        addressStreetName: null,//街镇名称
        addressStreetDetail: null,//所属街镇详细信息

        signatureCount: 50,
      },
      rules: {
        /**新增***/
        entName: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur'
          }
        ],
        devId: [
          {
            required: true,
            message: '请选择',
            trigger: 'blur'
          }
        ],
        entType: [
          {
            required: true,
            message: '请选择企业类型',
            trigger: 'blur'
          }
        ],
        legalName: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur'
          }
        ],
        contactName: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur'
          }
        ],
        creditCode: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur'
          }
        ],
        contactPhone: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur'
          }
        ],
        regAddressId: [
          {
            required: true,
            message: '请选择注册地址',
            trigger: 'blur'
          }
        ],
        workAddressId: [
          {
            required: true,
            message: '请选择办公地址',
            trigger: 'blur'
          }
        ],
        addressStreetId: [
          {
            required: true,
            message: '请选择所属街镇',
            trigger: 'blur'
          }
        ]
      },
      list: null,
      total: null,
      listLoading: true,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      tableKey: 0
    }
  },
  /**
   * 创建实例执行
   */
  created() {
    this.initForm = {...this.form};
    this.getList();
    this.getDevList();
  },
  computed: {
    ...mapGetters([
      'elements'
    ])
  },
  methods: {
    devName(devId){
        return this.devMap[`${devId}`];
    },
    getDevList(){
        getDevList({}).then(response=>{
           this.devList = response;
           this.devMap = response.reduce((o,v)=>{
               o[`${v.devId}`]=v.platformName;
               return o;
           },{});
        });
    },
    getList() {
      this.listLoading = true;
      listPage(this.listQuery).then(response => {
        this.list = response.rows;
        this.total = response.total;
        this.listLoading = false;
      })
      this.listLoading = false;
    },
    handleFilter() {
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleCreate() {
      this.resetTemp();
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
    },
    handleUpdate(row) {
      enterpriseDetail({entId: row.entId})
      .then(response => {
        this.form = response;
        this.dialogFormVisible = true;
        this.dialogStatus = 'update';
      });
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          delObj(row.entId).then(() => {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success',
              duration: 2000
            });
            const index = this.list.indexOf(row);
            this.list.splice(index, 1);
          });
      });
    },

    create(formName) {
      const set = this.$refs;
      set[formName].validate(valid => {
        if (valid) {
          console.log(this.form);
          addObj(this.form)
              .then(() => {
                this.dialogFormVisible = false;
                this.getList();
                this.$notify({
                  title: '成功',
                  message: '创建成功',
                  type: 'success',
                  duration: 2000
                });
              })
        } else {
          return false;
        }
      });
    },
    cancel(formName) {
      this.dialogFormVisible = false;
      const set = this.$refs;
      set[formName].resetFields();
    },
    update(formName) {
      const set = this.$refs;
      set[formName].validate(valid => {
        if (valid) {
          this.dialogFormVisible = false;
          putObj(this.form).then(() => {
            this.dialogFormVisible = false;
            this.getList();
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            });
          });
        } else {
          return false;
        }
      });
    },
    handleOpen(row) {
        //开通服务
        this.dialogServiceVisible=true;
        this.currentEntId = row.entId;
    },
    handleClick(row) {
        //详情
        this.dialogDetailVisible=true;
        this.currentEntId = row.entId;
    },
    handleAudit(row) {
        //详情
        this.dialogAuditVisible=true;
        this.currentEntId = row.entId;
    },
    close(flush){
        this.dialogFormVisible=false;
        this.dialogAuditVisible=false;
        this.dialogDetailVisible=false;
        this.dialogServiceVisible=false;
        flush && this.getList();
    },
    resetTemp() {
      this.form = this.initForm;
    },
    resetForm() {
      this.listQuery = {};
      this.areaOptions = [];
    },
  }
}
</script>

